import * as Sentry from '@sentry/angular';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private orderHash: string;
  constructor() {}

  setOrderHash(orderHash: string) {
    this.orderHash = orderHash;
    this.setUserContext(orderHash);
  }

  getOrderHash(): string {
    return this.orderHash;
  }

  private setUserContext(orderHash: string) {
    Sentry.setUser({
      id: orderHash
    });
  }
}
